
(function (window, document, undefined) {

if (!Math.intersect) {
    Math.intersect = function(line1StartX, line1StartY, line1EndX, line1EndY, line2StartX, line2StartY, line2EndX, line2EndY) {
        // if the lines intersect, the result contains the x and y of the intersection (treating the lines as infinite) and booleans for whether line segment 1 or line segment 2 contain the point
        var denominator, a, b, numerator1, numerator2, result = {
            x: null,
            y: null,
            onLine1: false,
            onLine2: false
        };
        denominator = ((line2EndY - line2StartY) * (line1EndX - line1StartX)) - ((line2EndX - line2StartX) * (line1EndY - line1StartY));
        if (denominator == 0) {
            return result;
        }
        a = line1StartY - line2StartY;
        b = line1StartX - line2StartX;
        numerator1 = ((line2EndX - line2StartX) * a) - ((line2EndY - line2StartY) * b);
        numerator2 = ((line1EndX - line1StartX) * a) - ((line1EndY - line1StartY) * b);
        a = numerator1 / denominator;
        b = numerator2 / denominator;

        // if we cast these lines infinitely in both directions, they intersect here:
        result.x = line1StartX + (a * (line1EndX - line1StartX));
        result.y = line1StartY + (a * (line1EndY - line1StartY));
            /*
            // it is worth noting that this should be the same as:
            x = line2StartX + (b * (line2EndX - line2StartX));
            y = line2StartX + (b * (line2EndY - line2StartY));
            */
        // if line1 is a segment and line2 is infinite, they intersect if:
        if (a > 0 && a < 1) {
            result.onLine1 = true;
        }
        // if line2 is a segment and line1 is infinite, they intersect if:
        if (b > 0 && b < 1) {
            result.onLine2 = true;
        }
        // if line1 and line2 are segments, they intersect if both of the above are true
        return result;
    }
};


L.LinkedPath = L.Polyline.extend({
    initialize: function (latlng, xy, options) {
        L.Polyline.prototype.initialize.call(this, [], options);

        this._latlng = this._convertLatLng(latlng);
        this._xy = xy;
    },

    options: {
        // how much to simplify the polyline on each zoom level
        // more = better performance and smoother look, less = more accurate
        color: "rgba(0, 0, 0, 0.6)",
        weight: 0.5,
        smoothFactor: 1.0,
        noClip: false
    },

    _projectLatlngs: function () {
        this._originalPoints = [
            this._map.latLngToLayerPoint(this._latlng),
            this._xy
        ];
    },

    getLatLngs: function () {
        // no usefull
        return this._latlng;
    },

    setLatLngs: function (latlng, xy) {
        this._latlng = this._convertLatLng(latlng);
        this._xy = xy;
        return this.redraw();
    },

    // addLatLng: function (latlng) {
    //     // no usefull
    //     return this;
    // },
    //
    // spliceLatLngs: function () { // (Number index, Number howMany)
    //     // no usefull
    //     return null;
    // },
    //
    // closestLayerPoint: function (p) {
    //     // no usefull
    //     return null;
    // },

    getBounds: function () {
        return new L.LatLngBounds(this.getLatLngs());
    },

    _convertLatLng: function (latlng, overwrite) {
        var target = overwrite ? latlng : {};

        if (L.Util.isArray(latlng) && typeof latlng[0] !== 'number') {
            return;
        }
        target = L.latLng(latlng);

        return target;
    },

    _clipPoints: function () {
        var points = this._originalPoints,
            len = points.length,
            i, k, segment;

        if (this.options.noClip) {
            this._parts = [points];
            return;
        }

        this._parts = [];

        var parts = this._parts,
            vp = this._map._renderer._bounds,
            lu = L.LineUtil;

        for (i = 0, k = 0; i < len - 1; i++) {
            segment = lu.clipSegment(points[i], points[i + 1], vp, i);
            if (!segment) {
                continue;
            }

            parts[k] = parts[k] || [];
            parts[k].push(segment[0]);

            // if segment goes out of screen, or it's the last one, it's the end of the line part
            if ((segment[1] !== points[i + 1]) || (i === len - 2)) {
                parts[k].push(segment[1]);
                k++;
            }
        }
    },

    // simplify each clipped part of the polyline
    _simplifyPoints: function () {
        var parts = this._parts,
            lu = L.LineUtil;

        for (var i = 0, len = parts.length; i < len; i++) {
            parts[i] = lu.simplify(parts[i], this.options.smoothFactor);
        }
    },

    _updatePath: function () {
        if (!this._map) { return; }

        this._clipPoints();
        this._simplifyPoints();

        L.Polyline.prototype._updatePath.call(this);
    }
});


L.LinkedTagDrag = L.Handler.extend({
    initialize: function (tag) {
        this._tag = tag;
    },

    addHooks: function () {
        var div = this._tag._container;
        if (!this._draggable) {
            this._draggable = new L.Draggable(div, div, true);
        }

        this._draggable.on({
            dragstart: this._onDragStart,
            // predrag: this._onPreDrag,
            drag: this._onDrag,
            dragend: this._onDragEnd
        }, this).enable();

        L.DomUtil.addClass(div, 'leaflet-marker-draggable');
    },

    removeHooks: function () {
        this._draggable.off({
            dragstart: this._onDragStart,
            // predrag: this._onPreDrag,
            drag: this._onDrag,
            dragend: this._onDragEnd
        }, this).disable();

        L.DomUtil.removeClass(this._tag._container, 'leaflet-marker-draggable');
    },

    moved: function () {
        return this._draggable && this._draggable._moved;
    },

    _onDragStart: function (e) {

        this._tag
            .fire('movestart')
            .fire('dragstart');
    },

    _onDrag: function (e) {
        var tag = this._tag,
            divPos = L.DomUtil.getPosition(tag._container),
            offset = tag.getOffset();

        tag.resetPosition(divPos);

        tag
            .fire('move', {pos: divPos})
            .fire('drag');
    },

    _onDragEnd: function (e) {
        this._tag
            .fire('moveend')
            .fire('dragend', e);
    }
});


L.LinkedTag = L.Popup.extend({
    options: {
        className: '',
        clickable: false,
        draggable: true,
        noHide: true,
        zoomAnimation: true,
        offset: [48, -48],
        'color': '#777',
        'fillColor': "rgba(255, 255, 245, 0.4)",
        'font': '16px Verdana',
        'padding': '2px 4px',
        'border-width': '2px',
        'border-color': '#777',
        'letterSpacing': null,
        lineOptions: {}
    },

    initialize: function (options, source) {
        L.setOptions(this, options);
        var defaultFont = 'Verdana';
        var _ff = this.options.font.split(' ');
        if (_ff.length < 2) {
            this.options.font += ' ' + defaultFont;
        }
        if (!this.options['font-color']) {
            this.options['font-color'] = this.options.color;
        }

        this._source = source;
    },

    onAdd: function (map) {
        L.DivOverlay.prototype.onAdd.call(this, map);

        this._initInteraction();

        if (this._line) {
            map.addLayer(this._line);
        }
    },

    onRemove: function (map) {
        L.DivOverlay.prototype.onRemove.call(this, map);

        this._removeInteraction();

        if (this._line) {
            map.removeLayer(this._line);
        }

        //試試看先不要拿掉 不知道做delete會不會影響drag
        // delete this._container;
        // this._content_canvas = null;

        this._map = null;
    },

    setLatLng: function (latlng) {
        this._latlng = L.latLng(latlng);
        if (this._map) {
            this._updatePosition();
        }
        return this;
    },

    _close: function () {
        var map = this._map;

        if (map) {
            if (L.Browser.touch && !this.options.noHide) {
                L.DomEvent.off(this._container, 'click', this.close);
            }

            map.removeLayer(this);
        }
    },

    setOpacity: function (opacity) {
        this.options.opacity = opacity;

        if (this._container) {
            L.DomUtil.setOpacity(this._container, opacity);
        }
    },

    _initLayout: function () {
        this._container = L.DomUtil.create('div', 'leaflet-linkedtag ' + this.options.className + ' leaflet-zoom-animated');

        if (typeof(this.options.opacity) !== 'undefined') {
            this.setOpacity(this.options.opacity);
        }
    },

    update: function () {
        if (!this._map) { return; }

        this._container.style.visibility = 'hidden';

        this._updateContent();
        this._updatePosition();

        this._container.style.visibility = '';
    },

    _fillText: function(context, text, x, y, spacing) {
        if (!spacing) {
            context.fillText(text, x, y);
            return;
        }

        //Start at position (X, Y).
        //Measure wAll, the width of the entire string using measureText()
        var wAll = context.measureText(text).width;
        var wShorter = 0;

        do {
            //Remove the first character from the string
            var char = text.substr(0, 1);
            text = text.substr(1);

            //Print the first character at position (X, Y) using fillText()
            context.fillText(char, x, y);

            //Measure wShorter, the width of the resulting shorter string using measureText().
            if (text == "")
                wShorter = 0;
            else
                wShorter = context.measureText(text).width;

            //Subtract the width of the shorter string from the width of the entire string, giving the kerned width of the character, wChar = wAll - wShorter
            var wChar = wAll - wShorter;

            //Increment X by wChar + spacing
            x += wChar + spacing;

            //wAll = wShorter
            wAll = wShorter;

            //Repeat from step 3
        } while (text != "");
    },

    _measureTextWidth: function(context, text, spacing) {
        if (!spacing) {
            return context.measureText(text).width;
        }

        var wAll = context.measureText(text).width;
        do {
            //Remove the first character from the string
            text = text.substr(1);
            wAll += spacing;
        } while (text != "");
        return wAll - spacing;
    },

    _parse_str_to_int: function(txt) {
        if (txt.length > 2) {
            if (txt.charAt(txt.length-2) == 'p') {
                txt = txt.substr(0, txt.length-2);
            }
        }
        try {
            return parseInt(txt, 10);
        }
        catch(e) {}
        return 0;
    },

    _updateContent: function () {
        if (!this._content || !this._map || this._prevContent === this._content) {
            return;
        }
        if (typeof this._content === 'string') {
            var ctx = null;

            if (this._content_canvas) {
                ctx = this._content_canvas.getContext("2d");
                ctx.clearRect(0, 0, this._content_canvas.width, this._content_canvas.height);
            }
            else {
                this._content_canvas = L.DomUtil.create('canvas', '');
                this._container.appendChild(this._content_canvas);
                ctx = this._content_canvas.getContext("2d");
            }

            if (this.options.font) {
                ctx.font = this.options.font;
            }
            var txtWidth = this._measureTextWidth(ctx, this._content, this.options['letterSpacing']);
            var txtHeight = 24;
            var canvasHeight = 24;
            try {
                var _font_size = ctx.font.split(' ')[0];
                txtHeight = canvasHeight = this._parse_str_to_int(_font_size);
            }
            catch(e) {}

            var _padding_left = 0, _padding_top = 0, _padding_right = 0, _padding_bottom = 0;
            if (this.options.padding) {
                var _type = typeof(this.options.padding);
                if (_type == 'string') {
                    var _txts = this.options.padding.split(' ');
                    if (_txts.length > 0) {
                        _padding_top = this._parse_str_to_int(_txts[0]);
                        if (_txts.length == 1) {
                            _padding_left = _padding_bottom = _padding_right = _padding_top;
                        }
                        else if (_txts.length >= 4) {
                            _padding_right = this._parse_str_to_int(_txts[1]);
                            _padding_bottom = this._parse_str_to_int(_txts[2]);
                            _padding_left = this._parse_str_to_int(_txts[3]);
                        }
                        else {
                            _padding_left = _padding_right = this._parse_str_to_int(_txts[1]);
                            _padding_bottom = _padding_top;
                        }
                    }
                }
                else if (_type == 'number') {
                    _padding_left = _padding_right = this.options.padding;
                    _padding_top = _padding_bottom = this.options.padding;
                }
            }

            var _border = 0;
            if (this.options['border-width']) {
                var _type = typeof(this.options['border-width']);
                if (_type == 'string') {
                    _border = this._parse_str_to_int(this.options['border-width']);
                }
                else if (_type == 'number') {
                    _border = this.options['border-width'];
                }
                _padding_left += _border;
                _padding_top += _border;
            }

            if (_padding_left > 0 || _padding_right > 0) {
                txtWidth += (_padding_left + _padding_right);
            }
            if (_padding_top > 0 || _padding_bottom > 0) {
                canvasHeight += (_padding_top + _padding_bottom);
            }

            if (this.options['border-radius']) {
                txtWidth += 2;
                canvasHeight += 2;
            }

            this._content_canvas.width = txtWidth;
            this._content_canvas.height = canvasHeight;

            if (this.options.fillColor) {
                ctx.fillStyle = this.options.fillColor;
            }
            if (this.options['border-radius']) {
                if (_border) {
                    ctx.strokeStyle = this.options['border-color'];
                }
                this.roundRect(ctx, 0, 0, txtWidth-2, canvasHeight-2,
                    this.options['border-radius'], _border,
                    this.options.fillColor);
            }
            else if (_border) {
                ctx.fillRect(0, 0, txtWidth, canvasHeight);
                ctx.lineWidth = _border;
                if (this.options['border-color']) {
                    ctx.strokeStyle = this.options['border-color'];
                }
                ctx.strokeRect(0+(_border/2), 0+(_border/2), txtWidth-_border, canvasHeight-_border);
            }
            else {
                ctx.fillRect(0, 0, txtWidth, txtHeight);
            }

            ctx.fillStyle = this.options['font-color'];
            if (this.options.font) {
                ctx.font = this.options.font;
            }

            if (this.options['border-radius']) {
                this._fillText(ctx, this._content,
                    _padding_left, txtHeight + _padding_top - 4,
                    this.options['letterSpacing']);
            }
            else {
                this._fillText(ctx, this._content,
                    _padding_left, txtHeight + _padding_top - 3,
                    this.options['letterSpacing']);
            }
        }
    },

    roundRect: function(ctx, x, y, width, height, radius, border) {
        if (border <= 0) {
            border = 1;
            ctx.strokeStyle = 'rgba(0, 0, 0, 0.0)';
        }
        x += border;
        y += border;
        width -= (border * 2);
        height -= (border * 2);

        ctx.beginPath();
        ctx.lineWidth = border * 2;
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();
        ctx.stroke();
        ctx.fill();
    },

    _updatePosition: function () {
        var pos = this._map.latLngToLayerPoint(this._latlng);

        this._setPosition(pos);
    },

    _animateZoom: function (e) {
        var pos = this._map._latLngToNewLayerPoint(this._latlng, e.zoom, e.center),
            anchor = this._getAnchor();
        this._setPosition(pos.add(anchor));
    },

    _setPosition: function (pos) {
        var map = this._map,
            container = this._container,
            centerPoint = map.latLngToContainerPoint(map.getCenter()),
            tagPoint = map.layerPointToContainerPoint(pos),
            tagWidth = this._tagWidth;

        if (!this._offset) {
            this._offset = L.point(this.options.offset);
        }

        var offx = parseInt(this._container.clientWidth / 2.0 + 0.5),
            offy = parseInt(this._container.clientHeight / 2.0 + 0.5);

        this._pos = pos.add(this._offset);

        this._setLinePosition(this._pos);

        var _pos = this._pos.subtract(L.point(offx, offy));
        L.DomUtil.setPosition(container, _pos);
    },

    resetPosition: function(pos) {
        var offx = parseInt(this._container.clientWidth / 2.0 + 0.5),
            offy = parseInt(this._container.clientHeight / 2.0 + 0.5);

        var marker_pos = this._map.latLngToLayerPoint(this._latlng);

        this._pos = pos.add(L.point(offx, offy));
        this._offset = this._pos.subtract(marker_pos);
        this._setLinePosition(this._pos);
    },

    _intersect_pos: function(latlng, center_pos) {
        var self = this;
        var left, top, right, bottom, rs, from_pos = null,
            ww = 20, hh = 20;
        if (self._map) {
            var to_pos = self._map.latLngToLayerPoint(latlng);

            if (self._content_canvas) {
                ww = self._content_canvas.width / 2.0;
                hh = self._content_canvas.height / 2.0;
            }
            left = center_pos.x - ww - 1;
            right = center_pos.x + ww + 1;
            top = center_pos.y - hh - 3;
            if (self.options['border-radius']) {
                bottom = center_pos.y + hh - 4;
            }
            else if (self.options['border-width']) {
                bottom = center_pos.y + hh - 3;
            }
            else {
                bottom = center_pos.y + hh - 2;
            }

            while(true) {
                // bottom line
                rs = Math.intersect(
                        center_pos.x, center_pos.y, to_pos.x, to_pos.y,
                        left, bottom, right, bottom
                    );
                if (rs.onLine1 && rs.onLine2) {
                    from_pos = {x: rs.x, y: rs.y};
                    break;
                }
                // left line
                rs = Math.intersect(
                        center_pos.x, center_pos.y, to_pos.x, to_pos.y,
                        left, top, left, bottom
                    );
                if (rs.onLine1 && rs.onLine2) {
                    from_pos = {x: rs.x, y: rs.y};
                    break;
                }
                // top line
                rs = Math.intersect(
                        center_pos.x, center_pos.y, to_pos.x, to_pos.y,
                        left, top, right, top
                    );
                if (rs.onLine1 && rs.onLine2) {
                    from_pos = {x: rs.x, y: rs.y};
                    break;
                }
                // right line
                rs = Math.intersect(
                        center_pos.x, center_pos.y, to_pos.x, to_pos.y,
                        right, top, right, bottom
                    );
                if (rs.onLine1 && rs.onLine2) {
                    from_pos = {x: rs.x, y: rs.y};
                    break;
                }
                break;
            }
        }
        return from_pos;
    },

    getEvents: function () {
        var events = L.DivOverlay.prototype.getEvents.call(this);

        return events;
    },

    _setLinePosition: function(pos) {
        var _bound_pos = this._intersect_pos(this._latlng, pos);
        if (_bound_pos) {
            if (!this._line) {
                this._line = new L.LinkedPath(this._latlng, _bound_pos);
                if (this.options.lineOptions) {
                    this._line.setStyle(this.options.lineOptions);
                }
            }
            else {
                this._line.setLatLngs(this._latlng, _bound_pos);
            }
        }
        else {
            //console.log(_bound_pos);
        }
    },

    getOffset: function() {
        return this._offset;
    },

    _onMoveEnd: function () {
        if (!this._animated) {
            this._updatePosition();
        }
    },

    _onViewReset: function (e) {
        /* if map resets hard, we must update the tag */
        if (e && e.hard) {
            this._update();
        }
    },

    _initInteraction: function () {
        var container = this._container,
            events = ['dblclick', 'mousedown', 'mouseover', 'mouseout', 'contextmenu'];

        L.DomUtil.addClass(container, 'leaflet-clickable');
        L.DomEvent.on(container, 'click', this._onMouseClick, this);

        for (var i = 0; i < events.length; i++) {
            L.DomEvent.on(container, events[i], this._fireMouseEvent, this);
        }

        if (L.LinkedTagDrag) {
            this.dragging = new L.LinkedTagDrag(this);

            if (this.options.draggable) {
                this.dragging.enable();
            }
        }
    },

    _removeInteraction: function () {
        var container = this._container,
            events = ['dblclick', 'mousedown', 'mouseover', 'mouseout', 'contextmenu'];

        L.DomUtil.removeClass(container, 'leaflet-clickable');
        L.DomEvent.off(container, 'click', this._onMouseClick, this);

        for (var i = 0; i < events.length; i++) {
            L.DomEvent.off(container, events[i], this._fireMouseEvent, this);
        }

        if (this.dragging) {
            this.dragging.disable();
        }
    },

    _onMouseClick: function (e) {
        var wasDragged = this.dragging && this.dragging.moved();

        if (this.hasEventListeners(e.type)) {
            L.DomEvent.stopPropagation(e);
        }

        if (wasDragged) { return; }

        if ((!this.dragging || !this.dragging._enabled) && this._map.dragging && this._map.dragging.moved()) { return; }

        this.fire(e.type, {
            originalEvent: e,
            offset: this._offset
        });
    },

    _fireMouseEvent: function (e) {
        this.fire(e.type, {
            originalEvent: e
        });

        // TODO proper custom event propagation
        // this line will always be called if marker is in a FeatureGroup
        if (e.type === 'contextmenu' && this.hasEventListeners(e.type)) {
            L.DomEvent.preventDefault(e);
        }
        if (e.type !== 'mousedown') {
            L.DomEvent.stopPropagation(e);
        } else {
            L.DomEvent.preventDefault(e);
        }
    }
});

L.MarkerLinkedTag = {
    showTag: function () {
        this.options.tagVisible = true;
        if (this.tag && this._map) {
            this.tag.setLatLng(this._latlng);
            this._map.showTag(this.tag);
        }

        return this;
    },

    hideTag: function () {
        this.options.tagVisible = false;
        if (this.tag) {
            this.tag._close();
        }
        return this;
    },

    isTagVisible: function() {
        return this.options.tagVisible;
    },

    setTagNoHide: function (noHide) {
        if (this.options.tagNoHide === noHide) {
            return;
        }

        this._tagNoHide = noHide;

        if (noHide) {
            this._removeTagRevealHandlers();
            this.showTag();
        } else {
            this._addTagRevealHandlers();
            this.hideTag();
        }
    },

    bindTag: function (content, options) {
        options = L.Util.extend({noHide: true}, options);

        this._tagNoHide = options.noHide;
        if (!this.tag) {
            if (!this._tagNoHide) {
                this._addTagRevealHandlers();
            }

            this
                .on('remove', this._onMarkerRemove, this)
                .on('move', this._moveTag, this)
                .on('add', this._onMarkerAdd, this);

            this._hasTagHandlers = true;
        }
        else {
            this.unbindTag();
        }

        if (typeof content === 'string') {
            this.tag = new L.LinkedTag(options, this)
                .setContent(content);
        }
        else if (content._source === null) {
            this.tag = content;
            content._source = this;
        }

        return this;
    },

    unbindTag: function () {
        if (this.tag) {
            this.hideTag();

            this.tag = null;

            if (this._hasTagHandlers) {
                if (!this._tagNoHide) {
                    this._removeTagRevealHandlers();
                }

                this
                    .off('remove', this._onMarkerRemove, this)
                    .off('move', this._moveTag, this)
                    .off('add', this._onMarkerAdd, this);
            }

            this._hasTagHandlers = false;
        }
        return this;
    },

    updateTagContent: function (content) {
        if (this.tag) {
            this.tag.setContent(content);
        }
    },

    getTag: function () {
        return this.tag;
    },

    _onMarkerAdd: function () {
        if (this.options.tagVisible) {
            if (this.tag && this._map) {
                this.tag.setLatLng(this._latlng);
                this._map.showTag(this.tag);
            }
        }
    },

    _onMarkerRemove: function () {
        if (this.tag) {
            this.tag._close();
        }
    },

    _addTagRevealHandlers: function () {
        this
            .on('mouseover', this.showTag, this)
            .on('mouseout', this.hideTag, this);

        if (L.Browser.touch) {
            this.on('click', this.showTag, this);
        }
    },

    _removeTagRevealHandlers: function () {
        this
            .off('mouseover', this.showTag, this)
            .off('mouseout', this.hideTag, this);

        if (L.Browser.touch) {
            this.off('click', this.showTag, this);
        }
    },

    _moveTag: function (e) {
        this.tag.setLatLng(e.latlng);
    }
};

L.Marker.include(L.MarkerLinkedTag);

L.Map.include({
    showTag: function (tag) {
        return this.addLayer(tag);
    }
});


}(this, document));



// WEBPACK FOOTER //
// ./src/assets/cb/leaflet/leaflet-linkedtag.js